import { isEmpty } from "ramda";
import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import {
  selectShouldDisplayError,
  setErrorVisibility,
  selectErrorMessage,
} from "../formSettings.slice";

import { Toast } from "./Toast";

export const Errors = (): JSX.Element => {
  const {
    formState: { isSubmitted, errors },
  } = useFormContext();
  const dispatch = useDispatch();
  const isToastVisible = useSelector(selectShouldDisplayError);
  const errorMessage = useSelector(selectErrorMessage);
  const doesFormContainErrors = !isEmpty(errors);
  const errorsRef = useRef(errors);

  useEffect(() => {
    if (isSubmitted && errorsRef.current !== errors) {
      errorsRef.current = errors;
      dispatch(setErrorVisibility(isSubmitted && doesFormContainErrors));
    }
  }, [
    dispatch,
    isSubmitted,
    doesFormContainErrors,
    isToastVisible,
    errorsRef,
    errors,
  ]);

  const handleClose = () => {
    dispatch(setErrorVisibility(false));
  };

  return (
    <Toast
      isVisible={isToastVisible}
      handleClose={handleClose}
      message={errorMessage}
    />
  );
};
